import { ReactPortal, useEffect, useRef } from "react";
import * as React from "react";
import { CSSProperties, useState } from "react";
import {
  Arrow,
  DisappearType,
  IBounds,
  TriggerProps,
  useLayer,
} from "react-laag";
import "../../styles/popup/dropdown.css";
import "../../styles/popup/tooltip.css";

export { useDropdown };

type Props = {
  containerRef: React.MutableRefObject<HTMLElement | null | undefined>;
  /* default: Close tooltip. */
  onOutsideClick?: VoidFunction;
  /* default: Close tooltip when fully disappeared. */
  onDisappear?: (disappearType: DisappearType) => void;
  /* default: Close tooltip. */
  onParentClose?: VoidFunction;
  /* style for .tooltip element. */
  tooltipLayerStyle?: CSSProperties;
  /* Dropdown options */
  options: { [key in string]: string };
  /* Selected dropdown option */
  selected: string;
  onSelect: (value: string) => void;
};
type DropdownReturn = {
  /* If dropdown visible */
  isOpen: boolean;
  /* Set dropdown visibility */
  setOpen: (open: boolean) => void;
  /* Render tooltip method */
  renderTooltip: () => React.ReactPortal | null;
  /* TODO: describe */
  triggerProps: TriggerProps;
  /* TODO: describe */
  triggerBounds: DOMRect | IBounds | null;
  /** MouseOver event listener to open tooltip */
  // triggerMouseOver: VoidFunction;
  /** MouseOut event listener to close tooltip if mouse not approaching tooltip. */
  // triggerMouseOut: React.MouseEventHandler<HTMLElement>;
};
const useDropdown = <O,>(props: Props): DropdownReturn => {
  const idRef = useRef(Math.random());

  const [isOpen, setOpen] = useState<boolean>(false);

  const {
    renderLayer,
    triggerProps,
    layerProps,
    arrowProps,
    layerSide,
    triggerBounds,
  } = useLayer({
    // default to above, so below inputs are visible. eg, <FuzzyMatcherEditor />, <FuzzyFieldMatcherEditor />
    placement: "bottom-center",
    possiblePlacements: ["bottom-center"],
    isOpen,
    overflowContainer: props.containerRef?.current ? true : false,
    // placement: 'bottom-end',
    onOutsideClick:
      props.onOutsideClick ??
      (() => {
        setOpen(false);
      }),
    auto: true,
    containerOffset: 11,
    // arrowOffset: ARROW_OFFSET,
    // attach to button
    // TODO: figure out if container required or not
    // container: props.containerRef?.current ?? undefined,
    onDisappear:
      props.onDisappear ??
      ((disappearType) => {
        if (disappearType == "full") {
          setOpen(false);
        }
      }),
    onParentClose:
      props.onParentClose ??
      (() => {
        setOpen(false);
      }),
  });

  // useEffect(() => {
  //     // call react-laag triggerRef, otherwise error !
  //     triggerProps?.ref(props.containerRef.current);
  // }, [props.containerRef, props.containerRef?.current]);

  const renderTooltip = (): ReactPortal | null => {
    return renderLayer(
      <div
        ref={layerProps.ref}
        style={{
          ...layerProps.style,
          ...props.tooltipLayerStyle,
        }}
        className={"tooltip dropdown " + layerSide}
        onClick={(e) => e.stopPropagation()}
        onMouseMove={(e) => e.stopPropagation()}
      >
        {/* TODO: render options */}

        {Object.keys(props.options).map((key) => (
          <div
            key={key}
            className={`${key === props.selected ? "selected" : ""}`}
            onClick={() => props.onSelect(key)}
          >
            <span>{props.options[key]}</span>
          </div>
        ))}

        <Arrow
          className={"arrow " + layerSide}
          {...arrowProps}
          size={5}
          roundness={0}
          id={idRef.current + ""}
        />
      </div>,
    );
  };

  return {
    renderTooltip,
    isOpen,
    setOpen,
    triggerBounds,
    triggerProps,
  };
};
